import React from 'react'
import { useTranslation } from 'react-i18next';

export default function Message() {
  const { t } = useTranslation();
  return (
    <main className="main-wrapper login-page">
      <div className="container-login">
        <form className="box-login">
          <h5 className="mb-4">{t('message.email_sent')}</h5>
        </form>
      </div>
    </main>
  )
}
